const scrollTable = function (el) {
    let offsetHeight = el.offsetHeight;
    let timer = null;
    let scrollHeight = el.firstElementChild.scrollHeight;

    // 如果当前可滚动的高度小于外层容器高度。就不进行滚动
    if (scrollHeight <= offsetHeight) {
        return false;
    }

    el.appendChild(el.firstElementChild.cloneNode(true));

    function bindScroll() {
        timer = setInterval(() => {
            if (el.scrollTop > scrollHeight) {
                el.appendChild(el.removeChild(el.firstElementChild));
            }
            el.scrollTop++;
        }, 20);
    }
    bindScroll();
    el.addEventListener("mouseover", function () {
        clearInterval(timer);
    }, { passive: true });

    el.addEventListener("mouseleave", function () {
        bindScroll();
    }, { passive: true });

};

export default scrollTable;